module.exports = __webpack_public_path__ + "static/img/img_22.a6f44f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/images/img_22.png
// module id = jA+R
// module chunks = 2